import { render, staticRenderFns } from "./PointCreditTechcoinError.vue?vue&type=template&id=9aab1f34"
import script from "./PointCreditTechcoinError.vue?vue&type=script&lang=js"
export * from "./PointCreditTechcoinError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports